<template>
  <div>
    <!------------------
            HEADER
    -------------------->
    <div class="bg-white p-3 pl-4 page-header" ref="pageHeader" style="padding-bottom: 0">
      <div class="row d-flex align-items-center" style="max-width: 1000px">
        <div class="col">
          <div class="float-right">
            <div class="form-inline">
              <!---------------------------------
            HEADER ACTION BUTTONS
        ---------------------------------->
              <b-button
                variant="secondary"
                class="text-white"
                @click="saveRecordAndReturn"
                v-show="editMode"
                :disabled="!recordFormChanged"
              >
                <b-icon icon="check2" variant="white" class="mr-1" style="padding-top: 1px"></b-icon>
                Beleg speichern
              </b-button>
              <b-button
                v-if="
                  !editMode &&
                    this.$route.params &&
                    typeof this.$route.params.iid !== 'undefined' &&
                    ($root.$user.isPlaner || $root.$user.isAdmin)
                "
                class="ml-2"
                variant="white"
                @click="
                  editMode = !editMode;
                  recordFormChanged = false;
                "
                :disabled="!canBeEdited"
                :title="
                  record.Type == 3 && record.IsLast == 0
                    ? 'Nur die letzte Schlussrechnung eines Auftrags kann bearbeitet werden.'
                    : 'Rechnung bearbeiten'
                "
              >
                <b-icon icon="lock" variant="dark" class="" style="padding-top: 1px"></b-icon>
              </b-button>

              <b-button
                v-if="editMode && this.$route.params && typeof this.$route.params.iid !== 'undefined'"
                class="ml-2"
                variant="white"
                @click="editMode = !editMode"
              >
                <b-icon icon="unlock" variant="dark" class="" style="padding-top: 1px"></b-icon>
              </b-button>
              <b-button class="ml-2" variant="white" @click="openOrder" title="Auftrag öffnen">
                <b-icon icon="file-earmark" variant="dark"></b-icon>
              </b-button>
              <b-button class="ml-2" variant="white" @click="openInvoiceSheet" title="Rechnungsbegleitblatt öffnen">
                <b-icon icon="bookmarks" variant="dark"></b-icon>
              </b-button>
              <b-button
                class="ml-2"
                variant="white"
                @click="
                  initialState = true;
                  toggleCollapseAll();
                "
              >
                <b-icon icon="chevron-double-right" variant="dark"></b-icon>
              </b-button>
              <b-button class="ml-2" variant="white" @click="$router.go(-1)">
                <b-icon icon="x" variant="dark"></b-icon>
              </b-button>
            </div>
          </div>

          <div>
            <h4 style="display: flex">
              <svg
                width="24"
                height="24"
                fill="currentColor"
                class="bi-file-earmark me-2 b-icon bi"
                viewBox="0 0 16 16"
                version="1.1"
                id="svg4"
              >
                <path
                  d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z"
                  id="path2"
                />
                <path
                  d="m 5.1218042,10.781435 h 0.7648806 c 0.2424881,2.088851 1.6218635,3.295535 3.7970601,3.295535 0.4475591,0 0.8397131,-0.04893 1.1937321,-0.133116 V 13.00844 c -0.348262,0.08563 -0.75193,0.122323 -1.1937321,0.122323 -1.5110531,0 -2.4860418,-0.862019 -2.7162975,-2.348608 H 9.8578749 V 10.114413 H 6.9185181 V 9.4409161 c 0,-0.07915 0,-0.1575811 0.00576,-0.2367316 H 9.8585939 V 8.5371627 H 7.0055835 C 7.2847685,7.1714586 8.242488,6.3893088 9.6844639,6.3893088 c 0.4418031,0 0.8454701,0.035977 1.1937321,0.1273602 V 5.5819749 A 4.7612557,4.7612557 0 0 0 9.6844639,5.4423824 c -2.1068389,0 -3.4682256,1.1289724 -3.7733144,3.0940606 H 5.1218042 V 9.2041845 H 5.8485487 V 10.114413 H 5.1218042 v 0.667742 z"
                  id="path2-4"
                />
              </svg>
              <span
                style="
                  width: 600px;
                  display: inline-block;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                "
              >
                {{ order.Ordinal + ' ' + order.DisplayName }}
              </span>
            </h4>
            <div class="text-uppercase text-secondary">
              <small v-if="$route.path.endsWith('/create')">BELEG ERFASSEN</small>
              <small v-else>BELEG</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-white px-4 mt-0 pt-0" style="border-bottom: 1px solid #dee2e6" v-if="toggleUpperSection">
      <div class="row pt-2 pb-0" style="max-width: 1000px">
        <div class="col col-3">
          <label class="text-muted d-block mb-1"><small>Gesamtbudget</small></label>
          <div class="bg-light p-1">
            {{ $utils.formatCurrency(parseFloat(order.BudgetSaldo), SettingsStore) }}
          </div>
        </div>
        <div class="col col-3">
          <label class="text-muted d-block mb-1"><small>Nachtragsrückstellung</small></label>
          <div class="bg-light p-1">
            {{
              $utils.numberWithMaxFrictions(
                ((parseFloat(order.BudgetSaldo) -
                  (parseFloat(order.Amount) + parseFloat(order.AmountAddendumOrdered))) /
                  parseFloat(order.BudgetSaldo)) *
                  100,
                1
              )
            }}
            %
          </div>
        </div>
        <div class="col col-3">
          <label class="text-muted d-block mb-1"><small>&nbsp;</small></label>
          <div class="bg-light p-1">
            {{
              $utils.numberToCurrency(
                parseFloat(order.BudgetSaldo) - (parseFloat(order.Amount) + parseFloat(order.AmountAddendumOrdered)),
                SettingsStore.settings['Centbetraege']
              )
            }}
          </div>
        </div>
        <div class="col col-3">
          <label class="text-muted d-block mb-1"><small>Status</small></label>
          <div class="bg-light p-1">{{ order.ProcessStatus }}</div>
        </div>
      </div>
      <div class="row mt-0 pb-4" style="max-width: 1000px">
        <div class="col col-3" v-show="SettingsStore.settings['KGR_Selections_Active'] == 'true'">
          <label class="text-muted d-block mb-1"><small>Kostengruppe</small></label>
          <div class="bg-light p-1 text-nowrap">
            {{ order.KGR ? (order.KGR == '' ? '(leer)' : order.KGR) : '(leer)' }}
          </div>
        </div>
        <div class="col col-3" v-show="SettingsStore.settings['Responsible_Selections_Active'] == 'true'">
          <label class="text-muted d-block mb-1"><small>Verantwortlich</small></label>
          <div class="bg-light p-1">
            {{ order.Responsible ? (order.Responsible == '' ? '(leer)' : order.Responsible) : '(leer)' }}
          </div>
        </div>
        <div class="col col-3" v-show="SettingsStore.settings['FA1_Active'] == 'true'">
          <label class="text-muted d-block mb-1">
            <small>{{ SettingsStore.settings['FA1'] }}</small>
          </label>
          <div class="bg-light p-1">
            {{ order.FA1 ? (order.FA1 == '' ? '(leer)' : order.FA1) : '(leer)' }}
          </div>
        </div>
        <div class="col col-3" v-show="SettingsStore.settings['FA2_Active'] == 'true'">
          <label class="text-muted d-block mb-1">
            <small>{{ SettingsStore.settings['FA2'] }}</small>
          </label>
          <div class="bg-light p-1">
            {{ order.FA2 ? (order.FA2 == '' ? '(leer)' : order.FA2) : '(leer)' }}
          </div>
        </div>
      </div>
    </div>
    <div class="bg-white px-4 mt-0 pt-0" style="border-bottom: 1px solid #dee2e6" v-if="toggleUpperSection">
      <div class="row pt-2 pb-0" style="max-width: 1000px">
        <div class="col-3">
          <label class="text-muted d-block mb-1"><small>Auftragnehmer</small></label>
          <div class="bg-light p-1">
            {{ order.SupplierText }}
          </div>
        </div>
        <div class="col-6">
          <label class="text-muted d-block mb-1"><small>Auftragsstatus / Datum</small></label>
          <div class="bg-light p-1">
            {{ computeOrderStatus(order) }}
          </div>
        </div>
        <div class="col-3">
          <label class="text-muted d-block mb-1"><small>Freistellungsbescheinigung gültig bis</small></label>
          <div class="bg-light p-1">
            {{ order.FreistellungDatum ? $utils.SQLDateToGermanDate(order.FreistellungDatum) : '(leer)' }}
          </div>
        </div>
      </div>
      <div class="row mt-0" style="max-width: 1000px">
        <div class="col">
          <label class="text-muted d-block mb-1"><small>Gesamtauftrag</small></label>
          <div class="bg-light p-1">
            {{
              $utils.formatCurrency(parseFloat(order.Amount) + parseFloat(order.AmountAddendumOrdered), SettingsStore)
            }}
          </div>
        </div>
        <div class="col">
          <label class="text-muted d-block mb-1"><small>Hauptauftrag</small></label>
          <div class="bg-light p-1">
            {{ $utils.formatCurrency(order.Amount, SettingsStore) }}
          </div>
        </div>
        <div class="col">
          <label class="text-muted d-block mb-1"><small>Nachträge</small></label>
          <div class="bg-light p-1">
            {{ $utils.formatCurrency(order.AmountAddendumOrdered, SettingsStore) }}
          </div>
        </div>
        <div class="col">
          <label class="text-muted d-block mb-1"><small>SEB Vertragserfüllung</small></label>
          <div class="bg-light p-1">
            {{ $utils.formatCurrency(order.SEBAccumulated, SettingsStore) }}
          </div>
        </div>
      </div>
      <div class="row mt-0 pb-2" style="max-width: 1000px">
        <div class="col col-3">
          <label class="text-muted d-block mb-1"><small>Abgerechnet</small></label>
          <div class="bg-light p-1">
            {{ $utils.formatCurrency(parseFloat(order.Invoiced), SettingsStore) }}
          </div>
        </div>
        <div class="col col-3">
          <label class="text-muted d-block mb-1"><small>Obligo</small></label>
          <div class="bg-light p-1">
            {{ $utils.formatCurrency(order.ObligoAmount, SettingsStore) }}
          </div>
        </div>
        <div class="col col-3">
          <label class="text-muted d-block mb-1"><small>Schlussgerechnet</small></label>
          <div class="bg-light p-1">Nein</div>
        </div>
        <div class="col col-3">
          <label class="text-muted d-block mb-1"><small>Einbehalt Mängelhaftung</small></label>
          <div class="bg-light p-1">
            {{ $utils.formatCurrency(order.SFMAccumulated, SettingsStore) }}
          </div>
        </div>
      </div>
      <div class="row" style="max-width: 1000px">
        <div class="col text-center">
          <b-icon
            icon="chevron-double-up"
            style="color: #aaa"
            class="action-button"
            @click="toggleUpperSection = !toggleUpperSection"
          ></b-icon>
        </div>
      </div>
    </div>
    <div class="bg-white px-4 mt-0 pt-0" style="border-bottom: 1px solid #dee2e6" v-if="!toggleUpperSection">
      <div class="row" style="max-width: 1000px">
        <div class="col text-center">
          <b-icon
            icon="chevron-double-down"
            style="color: #aaa"
            class="action-button"
            @click="toggleUpperSection = !toggleUpperSection"
          ></b-icon>
        </div>
      </div>
    </div>
    <div
      class="main-canvas"
      :style="[
        toggleUpperSection
          ? { height: 'calc(100vh - 452px)', 'overflow-y': 'auto' } // opened state
          : { height: 'calc(100vh - 104px)', 'overflow-y': 'auto' } // collapsed state
      ]"
    >
      <!-- :style="[toggleUpperSection ? { 'height': 'calc(100vh - 839px); overflow-y: auto' } : { 'height': 'calc(100vh - 639px); overflow-y: auto' }]-->
      <b-overlay :show="isLoading" rounded="sm" spinner-variant="primary" opacity="0.6">
        <b-form ref="recordForm" id="recordForm" autocomplete="off">
          <div class="row" style="max-width: 1000px">
            <div class="col col-3">
              <label class="text-muted d-block mb-1"><small>Belegnummer</small></label>
              <b-input
                v-model="record.Index"
                @keyup="onFormFieldKeyUp"
                required
                :disabled="!editMode"
                :readonly="true"
              />
            </div>
            <div class="col col-3">
              <label class="text-muted d-block mb-1"><small>Belegart</small></label>
              <b-form-select
                ref="decisionSelect"
                :options="decisionOptions"
                v-model="record.Type"
                @change="onDecisionSelectChange"
                required
                :disabled="!editMode || (order.HasFinalInvoice > 0 && record.IsLast == 0)"
                :autofocus="this.$route.params.iid == null"
              />
            </div>
            <div class="col col-3">
              <label class="text-muted d-block mb-1"><small>Rechnungsnummer</small></label>
              <b-input
                v-model="record.RNumber"
                @keyup="onFormFieldKeyUp"
                required
                :disabled="!editMode"
                maxlength="50"
              />
            </div>
            <div class="col col-3">
              <label class="text-muted d-block mb-1"><small>Rechnungsdatum</small></label>
              <b-input
                v-model="record.RDate"
                @change="onFormFieldKeyUp"
                required
                :disabled="!editMode"
                type="date"
                max="2999-12-31"
              />
            </div>
          </div>
          <div class="row mt-4" style="max-width: 1000px">
            <div class="col">
              <h6>
                Rechnungssumme (ungeprüft{{
                  record.CreatedDate && record.CreatedDate != ''
                    ? ', erfasst am ' + $utils.SQLDateToGermanDate(record.CreatedDate)
                    : ''
                }})
              </h6>
              <hr class="mt-0 mb-2" />
            </div>
          </div>
          <div class="row ml-2" style="max-width: 977px">
            <div class="col col-3">
              <label class="text-muted d-block mb-1"><small>Art</small></label>
              <span id="egmTypeSelector">
                <b-form-group>
                  <b-form-radio-group
                    id="radio-group-zuwachs"
                    name="radio-sub-component-zuwachs"
                    v-model="record.AmountCheckedType"
                    :disabled="!editMode"
                    @change="
                      onFormFieldKeyUp();
                      calcComputedFields();
                    "
                  >
                    <b-form-radio value="Z" class="mr-2 text-muted">Zuwachs</b-form-radio>
                    <b-form-radio value="K" class="mr-0 text-muted">kumuliert</b-form-radio>
                  </b-form-radio-group>
                </b-form-group>
              </span>
            </div>
          </div>
          <div class="row ml-2" style="max-width: 977px">
            <div class="col col-3">
              <label class="text-muted d-block mb-1">
                <small>netto</small>
                {{ record.Amount }}
              </label>

              <AkCurrencyField
                v-model="record.Amount"
                @keyup="onFormFieldKeyUp"
                required
                :disabled="!editMode"
                min="0"
                max="100000000"
                @update="recalcMwstGeneric('netto', 'Amount', 'USt', 'UStValue', 'AmountBrutto')"
                form="recordForm"
              />
            </div>
            <div class="col col-3">
              <label class="text-muted d-block mb-1"><small>USt.-Satz</small></label>
              <b-input-group prepend="%" :class="{ readonly: !editMode }">
                <b-input
                  :min="0"
                  :max="100"
                  type="number"
                  v-model="record.USt"
                  @keyup="onFormFieldKeyUp"
                  required
                  :disabled="!editMode"
                  @update="recalcMwstGeneric('mwst', 'Amount', 'USt', 'UStValue', 'AmountBrutto')"
                  form="recordForm"
                  onkeypress="return (event.charCode !=45) // no minus sign allowed to be input"
                />
              </b-input-group>
            </div>
            <div class="col col-3">
              <label class="text-muted d-block mb-1"><small>USt.-Wert</small></label>

              <AkCurrencyField
                v-model="record.UStValue"
                @keyup="onFormFieldKeyUp"
                readonly
                :disabled="!editMode"
                min="0"
                max="100000000"
                form="recordForm"
              />
            </div>
            <div class="col col-3">
              <label class="text-muted d-block mb-1"><small>brutto</small></label>
              <AkCurrencyField
                v-model="record.AmountBrutto"
                @keyup="onFormFieldKeyUp"
                required
                :disabled="!editMode"
                @update="recalcMwstGeneric('brutto', 'Amount', 'USt', 'UStValue', 'AmountBrutto')"
                min="0"
                form="recordForm"
                max="100000000"
              />
            </div>
          </div>

          <div class="row mt-4" style="max-width: 1000px" v-if="editMode || record.Status == 2">
            <div class="col">
              <div class="float-right" v-if="editMode">
                <fieldset class="form-group">
                  <div>
                    <div
                      id="checked-selector"
                      role="radiogroup"
                      tabindex="-1"
                      class="btn-group-toggle btn-group btn-group-sm bv-no-focus-ring"
                    >
                      <label
                        class="btn btn-outline-danger btn-sm"
                        :class="{ active: record.Status == 1 }"
                        @click.stop.prevent="
                          onInvoiceCheckedChange();
                          onFormFieldKeyUp();
                        "
                      >
                        <input type="radio" name="radio-sub-component" value="1" />
                        Ungeprüft
                      </label>
                      <label
                        @click="
                          if (record.Status == 2) return;
                          record.Status = 2;
                          record.CheckedDate = $utils.currentBrowserDate();
                          record.UStChecked = record.USt;
                          record.AmountChecked = record.Amount;
                          recalcMwstGeneric(
                            'netto',
                            'AmountChecked',
                            'UStChecked',
                            'UStCheckedValue',
                            'AmountCheckedBrutto'
                          );
                          onFormFieldKeyUp();
                        "
                        class="btn btn-outline-success btn-sm"
                        :class="{ active: record.Status !== 1 }"
                      >
                        <input type="radio" name="radio-sub-component" value="2" />
                        Geprüft
                      </label>
                    </div>
                  </div>
                </fieldset>
              </div>
              <h6>
                Rechnungssumme (geprüft{{
                  record.CheckedDate && record.CheckedDate != ''
                    ? ' am ' + $utils.SQLDateToGermanDate(record.CheckedDate)
                    : ''
                }})
              </h6>
              <hr class="mt-0 mb-2" />
            </div>
          </div>
          <div v-if="record.Status == 2">
            <div class="row ml-2" style="max-width: 977px">
              <div class="col col-3">
                <!--
              <span class="float-right" id="egmTypeSelector">
s
              </span> -->
                <!---
                rausgenommen aus dem nachfolgenden input, weil es bei änderung den egmamount wert verändert hat
                  @change="
                    record.EGMAmount =
                      record.EGMProzent && record.AmountChecked
                        ? parseFloat(((record.AmountChecked * record.EGMProzent) / 100).toFixed(2))
                        : record.EGMAmount
                  "


              --->
                <label class="text-muted d-block mb-1"><small>netto</small></label>

                <AkCurrencyField
                  v-model="record.AmountChecked"
                  :state="isAmountCheckedLargerThanSum"
                  ref="AmountChecked"
                  input-ref="AmountChecked"
                  @keyup="onFormFieldKeyUp"
                  :disabled="!editMode"
                  min="0"
                  @update="
                    recalcMwstGeneric('netto', 'AmountChecked', 'UStChecked', 'UStCheckedValue', 'AmountCheckedBrutto');
                    calcComputedFields();
                  "
                  :required="record.Status == 2"
                  form="recordForm"
                  max="100000000"
                />
              </div>
              <div class="col col-3">
                <label class="text-muted d-block mb-1"><small>USt.-Satz</small></label>
                <b-input-group prepend="%" :class="{ readonly: !editMode }">
                  <b-input
                    :min="0"
                    :max="100"
                    v-model="record.UStChecked"
                    @keyup="onFormFieldKeyUp"
                    :disabled="!editMode"
                    type="number"
                    @update="
                      recalcMwstGeneric(
                        'mwst',
                        'AmountChecked',
                        'UStChecked',
                        'UStCheckedValue',
                        'AmountCheckedBrutto'
                      );
                      calcComputedFields();
                    "
                    lazy
                    :required="record.Status == 2 && record.AmountChecked != ''"
                    onkeypress="return (event.charCode !=45) // no minus sign allowed to be input"
                  />
                </b-input-group>
              </div>
              <div class="col col-3">
                <label class="text-muted d-block mb-1"><small>USt.-Wert</small></label>
                <AkCurrencyField
                  v-model="record.UStCheckedValue"
                  @keyup="onFormFieldKeyUp"
                  readonly
                  :disabled="!editMode"
                  min="0"
                  max="100000000"
                  form="recordForm"
                />
              </div>
              <div class="col col-3">
                <label class="text-muted d-block mb-1"><small>brutto</small></label>

                <AkCurrencyField
                  v-model="record.AmountCheckedBrutto"
                  @keyup="onFormFieldKeyUp"
                  :disabled="!editMode"
                  @update="
                    recalcMwstGeneric(
                      'brutto',
                      'AmountChecked',
                      'UStChecked',
                      'UStCheckedValue',
                      'AmountCheckedBrutto'
                    );
                    calcComputedFields();
                  "
                  min="0"
                  max="100000000"
                  form="recordForm"
                />
              </div>
            </div>
            <div class="row mt-4" style="max-width: 1000px">
              <div class="col">
                <h6>
                  <b-btn href="#" variant="transparent" class="p-0" @click="toggleCollapse('accordion1')">
                    <span v-show="isCollapseOpen('accordion1')">
                      <b-icon icon="chevron-down" />
                    </span>
                    <span v-show="!isCollapseOpen('accordion1')">
                      <b-icon icon="chevron-right" />
                    </span>
                  </b-btn>
                  <span class="action-button" @click="toggleCollapse('accordion1')">
                    Entgeltminderung mit Vorsteuerkürzung
                  </span>
                </h6>
              </div>
            </div>
            <b-collapse
              id="accordion1"
              role="tabpanel"
              :visible="isCollapseOpen('accordion1')"
              @shown="scrollIntoView('accordion1')"
            >
              <hr class="mt-0 mb-2" />
              <div class="row ml-2" style="max-width: 977px">
                <div class="col col-6">
                  <label class="text-muted d-block mb-1"><small>Kommentar</small></label>
                  <b-input
                    v-model="record.EGMComment"
                    lazy
                    @keyup="onFormFieldKeyUp"
                    :disabled="!editMode"
                    maxlength="100"
                  />
                </div>
                <div class="col col-3">
                  <label class="text-muted d-block mb-1"><small>Prozent</small></label>
                  <b-input-group prepend="%" :class="{ readonly: !editMode }">
                    <b-input
                      v-model="record.EGMProzent"
                      @keyup="onFormFieldKeyUp"
                      @update="
                        record.EGMAmount =
                          record.EGMProzent && record.AmountChecked
                            ? (parseFloat(record.AmountChecked) * parseFloat(record.EGMProzent)) / 100
                            : null;
                        calcComputedFields();
                      "
                      :disabled="!editMode"
                      lazy
                      type="number"
                      min="0"
                      max="100"
                      step="0.1"
                      onkeypress="return (event.charCode !=45) // no minus sign allowed to be input"
                    />
                  </b-input-group>
                </div>
                <div class="col col-3">
                  <label class="text-muted d-block mb-1"><small>Betrag</small></label>

                  <AkCurrencyField
                    :state="isAmountCheckedLargerThanSum"
                    v-model="record.EGMAmount"
                    ref="egmField"
                    @keyup="onFormFieldKeyUp"
                    @update="
                      record.EGMProzent =
                        record.EGMAmount && record.AmountChecked
                          ? parseFloat(((record.EGMAmount / record.AmountChecked) * 100).toFixed(1))
                          : record.EGMProzent;
                      calcComputedFields();
                    "
                    :disabled="!editMode"
                    min="0"
                    :max="record.AmountChecked"
                  />
                </div>
              </div>
            </b-collapse>

            <div class="row mt-4" style="max-width: 1000px" v-if="record.Type !== 1">
              <div class="col">
                <h6>
                  <b-btn href="#" variant="transparent" class="p-0" @click="toggleCollapse('accordion2')">
                    <span v-show="isCollapseOpen('accordion2')">
                      <b-icon icon="chevron-down" />
                    </span>
                    <span v-show="!isCollapseOpen('accordion2')">
                      <b-icon icon="chevron-right" />
                    </span>
                  </b-btn>
                  <span class="action-button" @click="toggleCollapse('accordion2')">
                    Sicherheitseinbehalt aus Vertragserfüllung
                  </span>
                </h6>
              </div>
            </div>
            <b-collapse
              v-if="record.Type !== 1"
              id="accordion2"
              role="tabpanel"
              :visible="isCollapseOpen('accordion2')"
              @shown="scrollIntoView('accordion2')"
            >
              <hr class="mt-0 mb-2" />
              <div class="row ml-2 align-items-end" style="max-width: 977px">
                <div class="col col-6">
                  <b-form-checkbox
                    v-model="record.BuergschaftCheck"
                    :value="true"
                    :unchecked-value="false"
                    :disabled="!editMode"
                    @change="
                      record.SEBAmount = null;
                      record.SEBPercent = null;
                      onFormFieldKeyUp();
                    "
                    class="mb-2"
                    ref="sefield"
                  >
                    Vertragserfüllungsbürgschaft liegt vor
                  </b-form-checkbox>
                </div>
                <div class="col col-3">
                  <label class="text-muted d-block mb-1"><small>Prozent</small></label>
                  <b-input-group prepend="%" :class="{ readonly: !editMode || record.BuergschaftCheck }">
                    <b-input
                      v-model="record.SEBPercent"
                      @keyup="onFormFieldKeyUp"
                      :disabled="!editMode || record.BuergschaftCheck"
                      min="0"
                      step="0.01"
                      lazy
                      type="number"
                      @update="
                        record.SEBAmount =
                          record.SEBPercent && record.AmountChecked
                            ? (parseFloat(record.AmountChecked) * parseFloat(record.SEBPercent)) / 100
                            : null;
                        calcComputedFields();
                      "
                      onkeypress="return (event.charCode !=45) // no minus sign allowed to be input"
                    />
                  </b-input-group>
                </div>
                <div class="col col-3">
                  <label class="text-muted d-block mb-1"><small>Betrag</small></label>

                  <AkCurrencyField
                    v-model="record.SEBAmount"
                    ref="sebField"
                    :state="isAmountCheckedLargerThanSum"
                    @keyup="onFormFieldKeyUp"
                    :disabled="!editMode || record.BuergschaftCheck"
                    min="0"
                    :max="record.AmountChecked"
                    @update="
                      record.SEBPercent =
                        record.SEBAmount && record.AmountChecked
                          ? parseFloat(((record.SEBAmount / record.AmountChecked) * 100).toFixed(1))
                          : record.SEBPercent;
                      calcComputedFields();
                    "
                  />
                </div>
              </div>
            </b-collapse>

            <div class="row mt-4" style="max-width: 1000px">
              <div class="col">
                <h6>
                  <b-btn href="#" variant="transparent" class="p-0" @click="toggleCollapse('egmo')">
                    <span v-show="isCollapseOpen('egmo')">
                      <b-icon icon="chevron-down" />
                    </span>
                    <span v-show="!isCollapseOpen('egmo')">
                      <b-icon icon="chevron-right" />
                    </span>
                  </b-btn>
                  <span class="action-button" @click="toggleCollapse('egmo')">
                    Entgeltminderung ohne Vorsteuerkürzung
                  </span>
                </h6>
              </div>
            </div>
            <b-collapse id="egmo" role="tabpanel" :visible="isCollapseOpen('egmo')" @shown="scrollIntoView('egmo')">
              <hr class="mt-0 mb-2" />
              <div class="row ml-2" style="max-width: 977px">
                <div class="col col-3">
                  <label class="text-muted d-block mb-1"><small>bisher vorgenommene Abzüge</small></label>

                  <AkCurrencyField v-model="record.SumPastEGMOAmount" @keyup="onFormFieldKeyUp" readonly disabled />
                </div>
                <div class="col col-3">
                  <label class="text-muted d-block mb-1"><small>Abzug diese Rechnung</small></label>

                  <AkCurrencyField
                    v-model="record.EGMOAmount"
                    ref="egmoamountfield"
                    @keyup="onFormFieldKeyUp"
                    :disabled="!editMode"
                    @update="calcComputedFields"
                  />
                </div>

                <div class="col col-3">
                  <label class="text-muted d-block mb-1"><small>neue Gesamtsumme Abzüge</small></label>
                  <AkCurrencyField :value="totalEGMO" @keyup="onFormFieldKeyUp" readonly disabled />
                </div>
              </div>
              <div class="row ml-2" style="max-width: 977px">
                <div class="col col-9">
                  <label class="text-muted d-block mb-1"><small>Kommentar</small></label>

                  <b-input
                    v-model="record.EGMOComment"
                    @keyup="onFormFieldKeyUp"
                    :disabled="!editMode"
                    lazy
                    maxlength="100"
                  />
                </div>
              </div>
            </b-collapse>

            <div class="row mt-4" style="max-width: 1000px" v-if="record.Type == 3">
              <div class="col">
                <h6>
                  <b-btn href="#" variant="transparent" class="p-0" @click="toggleCollapse('accordion3')">
                    <span v-show="isCollapseOpen('accordion3')">
                      <b-icon icon="chevron-down" />
                    </span>
                    <span v-show="!isCollapseOpen('accordion3')">
                      <b-icon icon="chevron-right" />
                    </span>
                  </b-btn>
                  <span class="action-button" @click="toggleCollapse('accordion3')">
                    Sicherheitseinbehalt für Mängelhaftung
                  </span>
                </h6>
              </div>
            </div>
            <b-collapse
              v-if="record.Type == 3"
              id="accordion3"
              role="tabpanel"
              :visible="isCollapseOpen('accordion3')"
              @shown="scrollIntoView('accordion3')"
            >
              <hr class="mt-0 mb-2" />
              <div class="row ml-2 mb-4 align-items-end" style="max-width: 977px">
                <div class="col col-3">
                  <b-form-checkbox
                    v-model="record.SFMCheck"
                    :value="true"
                    :unchecked-value="false"
                    :disabled="!editMode"
                    @change="onSFMCheckChange"
                    class="mb-0"
                  >
                    Mängelhaftungsbürgschaft liegt vor
                  </b-form-checkbox>
                </div>
                <div class="col col-3">
                  <label class="text-muted d-block mb-1"><small>Prozent</small></label>
                  <b-input-group prepend="%" :class="{ readonly: !editMode || record.SFMCheck }">
                    <b-input
                      v-model="record.SFMPercent"
                      @keyup="onFormFieldKeyUp"
                      :disabled="!editMode || record.SFMCheck == true"
                      min="0"
                      step="0.1"
                      max="100"
                      lazy
                      type="number"
                      @update="calcComputedFields"
                      @focus="pullDefaultFromOrder('SFMPercent')"
                      onkeypress="return (event.charCode !=45) // no minus sign allowed to be input"
                    />
                  </b-input-group>
                </div>
                <div class="col col-3">
                  <label class="text-muted d-block mb-1"><small>Betrag</small></label>

                  <AkCurrencyField
                    v-model="record.SFMAmount"
                    @keyup="onFormFieldKeyUp"
                    :disabled="!editMode || record.SFMCheck == true"
                    min="0"
                    @update="/*calcSFMAmount('SFMAmount')*/"
                    :max="record.SFMBasisAmount"
                  />
                </div>
                <div class="col col-3">
                  <label class="text-muted d-block mb-1"><small>von</small></label>
                  <b-input v-model="MSicherVons[order.MSicherVon]" disabled />
                </div>
              </div>
            </b-collapse>

            <div class="row mt-4" style="max-width: 1000px">
              <div class="col">
                <h6>
                  <b-btn href="#" variant="transparent" class="p-0" @click="toggleCollapse('skonto')">
                    <span v-show="isCollapseOpen('skonto')">
                      <b-icon icon="chevron-down" />
                    </span>
                    <span v-show="!isCollapseOpen('skonto')">
                      <b-icon icon="chevron-right" />
                    </span>
                  </b-btn>
                  <span class="action-button" @click="toggleCollapse('skonto')">Skontoabzug vereinbart</span>
                </h6>
              </div>
            </div>
            <b-collapse
              id="skonto"
              role="tabpanel"
              :visible="isCollapseOpen('skonto')"
              @shown="scrollIntoView('skonto')"
            >
              <hr class="mt-0 mb-2" />
              <div class="row ml-2 mb-4 align-items-end" style="max-width: 977px">
                <div class="col col-3">
                  <b-form-checkbox
                    v-model="record.SkontoCheck"
                    :value="true"
                    :unchecked-value="false"
                    :disabled="!editMode"
                    @change="onSkontoCheckChange"
                    class="mb-2"
                  >
                    Skontoabzug ausgewiesen
                  </b-form-checkbox>
                </div>
                <div class="col col-3">
                  <label class="text-muted d-block mb-1"><small>Skontofrist (Tage)</small></label>
                  <!-- <b-input-group prepend="€" :class="{ readonly: !editMode || !record.SkontoCheck }"> -->
                  <b-input
                    v-model="record.SkontoFrist"
                    @keyup="onFormFieldKeyUp"
                    :disabled="!editMode || !record.SkontoCheck"
                    lazy
                    type="number"
                    min="1"
                    max="50"
                    onkeypress="return (event.key !== '-' && event.key !== ',' && event.key !== '.') // no minus sign allowed to be input"
                    :required="record.SkontoCheck && record.SkontoCheck == true"
                  />
                  <!-- </b-input-group> -->
                </div>
                <div class="col col-3">
                  <label class="text-muted d-block mb-1"><small>Skonto %</small></label>
                  <b-input-group prepend="%" :class="{ readonly: !editMode || !record.SkontoCheck }">
                    <b-input
                      v-model="record.SkontoProzent"
                      @keyup="onFormFieldKeyUp"
                      @change="
                        onFormFieldKeyUp();
                        calcComputedFields();
                        /*
                        record.SkontoAmount =
                          record.AmountChecked &&
                          record.AmountChecked > 0 &&
                          record.SkontoProzent &&
                          record.SkontoProzent > 0
                            ? (record.AmountChecked * record.SkontoProzent) / 100
                            : null;*/
                      "
                      :disabled="!editMode || !record.SkontoCheck"
                      min="0.1"
                      step="0.1"
                      max="100"
                      lazy
                      type="number"
                      onkeypress="return (event.key !== '-') // no minus sign allowed to be input"
                    />
                  </b-input-group>
                </div>
                <div class="col col-3">
                  <label class="text-muted d-block mb-1"><small>Skontobetrag</small></label>

                  <AkCurrencyField v-model="record.SkontoAmount" disabled lazy />
                </div>
              </div>
            </b-collapse>
          </div>
        </b-form>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import AppState from '@/store/App.js';
import InvoicesService from '@/service/InvoicesService.js';
import OrdersService from '@/service/OrdersService.js';
import ProjectsService from '@/service/ProjectsService.js';
import SettingsStore from '@/store/Settings';
import AkCurrencyField from '@/components/AkCurrencyField';

export default {
  components: {
    AkCurrencyField
  },
  deactivated() {
    window.removeEventListener('keydown', this.goBackOnEsc); // Succeeds
  },
  async activated() {
    window.addEventListener('keydown', this.goBackOnEsc);
    this.initialState = true;
    setTimeout(() => {
      this.initialState = false;
    }, 1000);
    this.editMode = false;
    this.showValidations = false;
    this.record = {
      Index: null,
      OrderId: null,
      USt: null, //SettingsStore.settings['Mehrwertsteuersatz'],
      UStChecked: null, //SettingsStore.settings['Mehrwertsteuersatz'],
      AmountCheckedType: 'Z',
      EGMAmount: null,
      SFMCheck: null,
      SFMAmount: null,
      SFMPercent: null,
      BuergschaftCheck: null,
      SkontoProzent: null,
      SkontoAmount: null,
      SFMAmountBkp: null,
      SFMPercentBkp: null,
      EGMOAcc: null,
      EGMOAmount: null,
      Status: 1
    };
    if (this.$route.params.id) {
      await this.loadOrder();
      this.record.OrderId = this.order.DbId;
      this.record.USt = this.order.AmountMwSt;
      this.record.UStChecked = this.order.AmountMwSt;
    }

    if (this.$route.params.iid) {
      if (this.$route.params.iid == 'last') {
        await this.loadInvoice(true);
      } else {
        await this.loadInvoice();
      }
    }

    this.loadPrevious();

    if (this.$route.path.endsWith('/create')) {
      this.editMode = true;
      if (this.order.HasFinalInvoice > 0) {
        this.record.Type = 3;
        this.decisionOptions = [
          { value: 1, text: 'Rechnung', disabled: true },
          { value: 2, text: 'Abschlagsrechnung', disabled: true },
          { value: 3, text: 'Schlussrechnung' }
        ];
      }
      this.loadIndex();
      this.loadEGMOPastAmount();
    }

    this['collapse' + 'accordion1' + 'open'] = this.record.EGMAmount !== null; // true, false or undefined
    this['collapseskontoopen'] = this.record.SkontoCheck;
    this['collapse' + 'accordion2' + 'open'] = this.record.BuergschaftCheck || this.record.SEBAmount > 0;
    this['collapseaccordion3open'] = this.record.SFMCheck || this.record.SFMPercent != '';
    this['collapse' + 'egmo' + 'open'] = this.record.EGMOAmount !== null;

    AppState.isLoading = false;
    this.$forceUpdate();
    ////this.$root.$emit('bv::collapse::state', { collapseId: 'accordion1', isJustShown: true })
  },
  data() {
    return {
      console,
      SettingsStore,
      initialState: true,
      isLoading: false,
      editMode: false,
      previousRoutePath: '',
      order: {},
      record: {
        Index: null,
        OrderId: null,
        EGMAmount: null,
        SFMCheck: null,
        SFMAmount: null,
        SFMPercent: null,
        BuergschaftCheck: null,
        SkontoProzent: null,
        SkontoAmount: null,
        EGMOAcc: null,
        EGMOAmount: null,
        Status: 1
      },
      previousInvoice: {},
      previousInvoices: [],
      decisionOptions: [
        { value: 1, text: 'Rechnung' },
        { value: 2, text: 'Abschlagsrechnung' },
        { value: 3, text: 'Schlussrechnung' }
      ],
      allocationUnits: [],
      recordFormChanged: false,
      toggleUpperSection: true,
      collapseaccordion1open: false,
      collapseaccordion2open: false,
      collapseaccordion3open: false,
      collapseskontoopen: false,
      collapseegmoopen: false,
      showValidations: false,
      MSicherVons: ['Netto-Abrechnungssumme', 'Brutto-Abrechnungssumme']
    };
  },
  methods: {
    goBackOnEsc(e) {
      if (e.keyCode == 27) history.back();
    },
    toggleCollapse(which) {
      this.$root.$emit('bv::toggle::collapse', which);
      this['collapse' + which + 'open'] = !this['collapse' + which + 'open'];
    },
    toggleCollapseAll() {
      if (
        this.collapseaccordion1open ||
        this.collapseaccordion2open ||
        this.collapseaccordion3open ||
        this.collapseegmoopen ||
        this.collapseskontoopen
      ) {
        this.collapseaccordion1open = this.collapseaccordion2open = this.collapseaccordion3open = this.collapseegmoopen = this.collapseskontoopen = false;
      } else {
        this.collapseaccordion1open = this.collapseaccordion2open = this.collapseaccordion3open = this.collapseegmoopen = this.collapseskontoopen = true;
      }
      setTimeout(() => {
        this.initialState = false;
      }, 1000);
    },
    isCollapseOpen(which) {
      return this['collapse' + which + 'open'];
    },
    async loadOrder() {
      this.decisionOptions = [
        { value: 1, text: 'Rechnung' },
        { value: 2, text: 'Abschlagsrechnung' },
        { value: 3, text: 'Schlussrechnung' }
      ];
      if (this.$route.params.order) {
        this.order = this.$route.params.order;
        //        this.record.OrderId = this.order.DbId;
      } else {
        await OrdersService.getById(this.$route.params.id).then(order => {
          this.order = order;
          if (this.order.LastSFMCheck == 'true') {
            this.record.SFMCheck = true;
          } else {
            this.record.SFMCheck = false;
            //this.record.SFMPercent = this.order.MSicherProzent ? parseFloat(this.order.MSicherProzent) : null;
          }
          if (this.order.LastBuergschaftCheck == 'true') {
            this.record.BuergschaftCheck = true;
          } else {
            this.record.BuergschaftCheck = false;
          }
        });
      }
      /*
      if (this.order.HasFinalInvoice && this.order.HasFinalInvoice > 0) {
        this.decisionOptions = [
          { value: 1, text: 'Rechnung', disabled: true },
          { value: 2, text: 'Abschlagsrechnung', disabled: true },
          { value: 3, text: 'Schlussrechnung' }
        ];
      }*/
    },
    async loadInvoice() {
      await InvoicesService.getById(this.$route.params.iid, this.$route.params.id)
        .then(record => {
          this.record = record;

          if (!this.record.AmountCheckedType) this.record.AmountCheckedType = 'Z';
          record.EGMProzent =
            record.EGMAmount && record.AmountChecked
              ? parseFloat(((record.EGMAmount / record.AmountChecked) * 100).toFixed(1))
              : null;

          this.recalcMwstGeneric('netto', 'Amount', 'USt', 'UStValue', 'AmountBrutto');
          this.recalcMwstGeneric('netto', 'AmountChecked', 'UStChecked', 'UStCheckedValue', 'AmountCheckedBrutto');
          this.record.SEBPercent = this.record.SEBAmount
            ? parseFloat(
                this.$utils.numberWithMaxFrictions(
                  (parseFloat(this.record.SEBAmount) / parseFloat(this.record.AmountChecked)) * 100,
                  1
                )
              )
            : null;

          if (this.order.HasFinalInvoice && this.order.HasFinalInvoice > 0) {
            if (this.order.LastSFMCheck == 'true') {
              this.record.SFMCheck = true;
            } else {
              this.record.SFMCheck = false;
              //this.record.SFMPercent = this.order.MSicherProzent ? parseFloat(this.order.MSicherProzent) : null;
            }
            if (this.order.LastBuergschaftCheck == 'true') {
              this.record.BuergschaftCheck = true;
            } else {
              this.record.BuergschaftCheck = false;
            }

            if (this.record.Type == 3) {
              // eine schlussrechnung soll in andere rechnungsarten geändert werden können, aber nur wenn vor ihr keine andere SR mehr steht (also keine ältere SR außerdem existiert)
              var hasPreviousSR = false;
              this.previousInvoices.map(x => {
                if (x.Type == 3) hasPreviousSR = true;
              });
              this.decisionOptions = [
                { value: 1, text: 'Rechnung', disabled: hasPreviousSR },
                {
                  value: 2,
                  text: 'Abschlagsrechnung',
                  disabled: hasPreviousSR
                },
                { value: 3, text: 'Schlussrechnung' }
              ];
            }
          } else {
            this.decisionOptions = [
              { value: 1, text: 'Rechnung' },
              { value: 2, text: 'Abschlagsrechnung' },
              { value: 3, text: 'Schlussrechnung', disabled: this.record.IsLast == 0 }
            ];
          }
        })
        .catch(err => {
          console.log(err, err.response);
          if (err.response && err.response.data && err.response.data.error)
            this.$showError(this, err.response.data.error);
          if (err.response.status == 404) this.$router.push('/');
        });
    },
    loadPrevious() {
      InvoicesService.getAllPreviousById(this.$route.params.id, this.$route.params.iid).then(invoices => {
        if (invoices && invoices.length > 0) {
          invoices.sort((a, b) => b.Index - a.Index);
        }
        this.previousInvoices = invoices;
        if (invoices && invoices.length > 0) this.previousInvoice = invoices[0];
        this.calcComputedFields();
        //this.calcSFMAmount('SFMPercent');
        if (this.$route.path.endsWith('/create')) {
          this.record.SFMPercent = this.$utils.numberWithMaxFrictions(this.order.MSicherProzent, 1);
          this.record.BuergschaftCheck = false;
          if (this.previousInvoice.BuergschaftCheck && this.previousInvoice.BuergschaftCheck == 'true') {
            this.record.BuergschaftCheck = true;
            this['collapse' + 'accordion2' + 'open'] = true;
          } else {
            if (
              this.order.VErfuellCheck != null &&
              this.order.VErfuellCheck == 'true' &&
              this.order.VErfuellFile != null &&
              this.order.VErfuellFile != '' &&
              this.order.VErfuellArt != null &&
              this.order.VErfuellArt == 0
            ) {
              this.record.BuergschaftCheck = true;
              this['collapse' + 'accordion2' + 'open'] = true;
            }
          }
        }
      });
    },
    loadIndex() {
      ProjectsService.getZFIndex().then(response => {
        this.record.Index = response.ZFIndex;
      });
    },
    loadEGMOPastAmount() {
      InvoicesService.getEGMOPastAmount(this.$route.params.id).then(response => {
        this.record.SumPastEGMOAmount = response.SumPastEGMOAmount;
      });
    },
    pullDefaultFromOrder(field) {
      switch (field) {
        case 'SFMPercent':
          if (this.record.SFMPercent && this.record.SFMPercent != '') return;
          this.record.SFMPercent = this.$utils.numberWithMaxFrictions(this.order.MSicherProzent, 1);
          this.calcComputedFields();
          break;
      }
    },
    saveRecordAndReturn() {
      // remove all un-needed data attr
      if (this.record.Type == 1) {
        // rechnung, entferne SEB und SFM attribute
        // SEB
        this.record.SEBAmount = null;
        this.record.SEBCheck = null;
        // SFM
        this.record.SFMAmount = null;
        this.record.SFMCheck = null;
      } else if (this.record.Type == 2) {
        // abschlagsrechnung, entferne SFM attribute
        // SFM
        this.record.SFMAmount = null;
        this.record.SFMPercent = null;
        this.record.SFMCheck = null;
      } else if (this.record.Type == 3) {
        //this.record.SFMPercent = '';
        //this.record.SFMPercent = this.record.SFMPercent && this.record.SFMPercent != '' ? parseFloat(this.record.SFMPercent) : null;
      }

      if (!this.$refs.recordForm.checkValidity()) {
        return this.$refs.recordForm.reportValidity();
      }

      if (this.$refs.AmountChecked?.$refs.AmountChecked) {
        const input = this.$refs.AmountChecked.$refs.AmountChecked.$el;
        input.setCustomValidity('');

        if (
          (this.record.EGMAmount ? parseFloat(this.record.EGMAmount) : 0) +
            (this.record.SEBAmount ? parseFloat(this.record.SEBAmount) : 0) >
          (this.record.AmountChecked ? parseFloat(this.record.AmountChecked) : 0)
        ) {
          input.setCustomValidity(
            'Die Summe aus Umlagen und Sicherheitseinbehalt aus Vertragserfüllung überschreitet den geprüften Rechnungsbetrag.'
          );
          this.showValidations = true;
          return input.reportValidity();
        }
      }

      if (this.$route.params.iid) {
        // update
        // check if previous are all unchecked
        OrdersService.maybeUpdated(this.record.OrderId, this.record.Index).then(result => {
          if (this.record.IsLast == 0 && result.has == true) {
            this.$bvModal
              .msgBoxConfirm(
                'Sind Sie sicher, vorgenommene Änderungen zu übernehmen? Für diesen Auftrag bestehen bereits jüngere Rechnungen. Durch die Änderungen können sich Auswirkungen auf bereits geprüfte, jüngere Rechnungen ergeben. Kontrollieren Sie im Nachgang die zugehörige Rechnungsbegleitblätter dieser Rechnungen.',
                {
                  title: 'Beleg aktualisieren',
                  okTitle: 'Bestätigen',
                  cancelTitle: 'Abbrechen',
                  okVariant: 'danger',

                  centered: true
                }
              )
              .then(confirmed => {
                if (confirmed) {
                  this.isLoading = true;
                  InvoicesService.update(this.record)
                    .then(() => {
                      this.$showSuccess(this, 'Beleg aktualisieren', 'Beleg erfolgreich aktualisiert.');
                      this.$router.push('/invoices/' + this.$route.params.id);
                    })
                    .catch(err => {
                      if (err.response) this.$showError(this, err.response.data.error);
                      else this.$showError(this, err.toString());
                    })
                    .finally(() => {
                      this.isLoading = false;
                    });
                }
              });
          } else {
            this.isLoading = true;
            InvoicesService.update(this.record)
              .then(() => {
                this.$showSuccess(this, 'Beleg aktualisieren', 'Beleg erfolgreich aktualisiert.');
                this.$router.push('/invoices/' + this.$route.params.id);
              })
              .catch(err => {
                if (err.response) this.$showError(this, err.response.data.error);
                else this.$showError(this, err.toString());
              })
              .finally(() => {
                this.isLoading = false;
              });
          }
        });
      } else {
        // create
        this.isLoading = true;

        InvoicesService.create(this.record)
          .then(() => {
            this.$showSuccess(this, 'Beleg erstellen', 'Beleg erfolgreich erstellt.');
            this.$router.push(this.$route.path.replace('/create', ''));
          })
          .catch(err => {
            if (err.response) this.$showError(this, err.response.data.error);
            else this.$showError(this, err.toString());
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    openInvoiceSheet() {
      const routeData = this.$router.resolve({ name: 'Rechnungsbegleitblatt', query: { nav: 'false' } });
      window.open(routeData.href, '_blank');
    },
    openOrder() {
      this.$router.push('/orders/' + this.$route.params.id);
    },
    computeOrderStatus(item) {
      if (item.veSection && item.veSection == 'A') {
        return (
          (item.VergabeEmpfehlung && item.VergabeEmpfehlung != '' ? item.VergabeEmpfehlung : 'Empfehlung') +
          ' / ' +
          this.$utils.SQLDateToGermanDate(item.VergabeEmpfehlungDatum)
        );
      } else if (item.veSection && item.veSection == 'B') {
        return (
          (item.OrderNumber && item.OrderNumber != '' ? item.OrderNumber : 'Bestellung') +
          ' / ' +
          this.$utils.SQLDateToGermanDate(item.OrderDate)
        );
      } else return '';
    },
    recalcMwstGeneric(whatChanged, amount, uSt, uStValue, amountBrutto) {
      if (whatChanged == 'netto') {
        if (
          this.record[amount] == null ||
          this.record[amount] === '' ||
          this.record[uSt] == null ||
          this.record[uSt] === ''
        ) {
          this.record[amountBrutto] = null;
          this.record[uStValue] = null;
          return;
        }
        /*
        if (parseFloat(this.record[amount]) != 0 && this.record[uSt] && parseFloat(this.record[uSt]) == 0) {
          this.record[amountBrutto] = 0;
          this.record[uStValue] = 0;
          return;
        }
*/
        this.record[uStValue] = (parseFloat(this.record[amount]) * parseFloat(this.record[uSt])) / 100;

        this.record[amountBrutto] = parseFloat(this.record[amount]) + parseFloat(this.record[uStValue]);
      } else if (whatChanged == 'brutto') {
        if (
          this.record[amountBrutto] == null ||
          this.record[amountBrutto] === '' ||
          this.record[uSt] == null ||
          this.record[uSt] === ''
        ) {
          //this.record[amount] = null;
          this.record[uStValue] = null;
          return;
        }
        if (parseFloat(this.record[amountBrutto]) == 0 || !this.record[uSt] || parseFloat(this.record[uSt] == 0))
          return;

        this.record[amount] = this.formatDecimals(
          (parseFloat(this.record[amountBrutto]) * 100) / (100 + parseFloat(this.record[uSt]))
        ); // * 100/119
        this.record[uStValue] = this.formatDecimals((this.record[amount] * this.record[uSt]) / 100);
      } else if (whatChanged == 'mwst') {
        if (
          this.record[uSt] == null ||
          this.record[uSt] === '' ||
          this.record[amount] == null ||
          this.record[amount] === ''
        ) {
          //this.record[amount] = null;
          this.record[amountBrutto] = null;
          this.record[uStValue] = null;
          return;
        }
        this.record[uStValue] = this.formatDecimals((this.record[amount] * this.record[uSt]) / 100);
        this.record[amountBrutto] = this.formatDecimals(
          parseFloat(this.record[amount]) + parseFloat(this.record[uStValue])
        );
      }
    },
    /*
    calcSFMAmount() {

      if (whatChanged == 'SFMPercent') {
        if (this.record.SFMPercent && this.record.SFMPercent !== '' && this.record.LZWAccumulatedChecked) {
          this.record.SFMAmount = this.$utils.round((this.record.SFMPercent * this.record.SFMBasisAmount) / 100, 2);
        }
      } else if (whatChanged == 'SFMAmount') {
        if (this.record.SFMPercent && this.record.SFMPercent !== '' && this.record.LZWAccumulatedChecked) {
          this.record.SFMPercent = this.$utils.numberWithMaxFrictions(
            (this.record.SFMAmount / this.record.SFMBasisAmount) * 100,
            1
          );
        }
      }
    },*/
    calcComputedFields() {
      if (!this.previousInvoice) this.previousInvoice = {};
      if (!this.previousInvoice.LZWAccumulatedChecked) this.previousInvoice.LZWAccumulatedChecked = 0;
      if (!this.previousInvoice.LZWAmountChecked) this.previousInvoice.LZWAmountChecked = 0;
      if (!this.previousInvoice.EGMZWAmount) this.previousInvoice.EGMZWAmount = 0;
      if (!this.previousInvoice.EGMAcc) this.previousInvoice.EGMAcc = 0;
      if (!this.previousInvoice.SEBZWAmount) this.previousInvoice.SEBZWAmount = 0;
      if (!this.previousInvoice.SEBAcc) this.previousInvoice.SEBAcc = 0;
      if (!this.previousInvoice.ZAUStAmountSum) this.previousInvoice.ZAUStAmountSum = 0;
      if (!this.previousInvoice.SFMPreviousAmount) this.previousInvoice.SFMPreviousAmount = 0;
      if (!this.record.SFMPreviousAmount) this.record.SFMPreviousAmount = 0;
      if (this.record.AmountCheckedType == 'Z') {
        /* **********************

                  Z

        ************************ */
        this.record.LZWAccumulatedChecked = this.record.AmountChecked
          ? this.previousInvoice.LZWAccumulatedChecked + parseFloat(this.record.AmountChecked)
          : this.previousInvoice.LZWAccumulatedChecked;
        this.record.LZWAmountChecked = this.record.AmountChecked ? parseFloat(this.record.AmountChecked) : 0;
        this.record.EGMZWAmount = this.record.EGMAmount ? parseFloat(this.record.EGMAmount) : 0;
        this.record.EGMAcc =
          this.record.EGMAmount && parseFloat(this.record.EGMAmount) > 0
            ? this.previousInvoice.EGMAcc + parseFloat(this.record.EGMAmount)
            : this.previousInvoice.EGMAcc;
        this.record.SEBZWAmount = this.record.SEBAmount ? parseFloat(this.record.SEBAmount) : 0;
        this.record.SEBAcc = this.record.SEBAmount
          ? this.previousInvoice.SEBAcc + this.record.SEBAmount
          : this.previousInvoice.SEBAcc;
      } else if (this.record.AmountCheckedType == 'K') {
        /* **********************

                  K

        ************************ */
        this.record.LZWAccumulatedChecked = this.previousInvoice.LZWAccumulatedChecked
          ? parseFloat(this.record.AmountChecked)
          : parseFloat(this.record.AmountChecked);
        this.record.LZWAmountChecked = this.record.AmountChecked
          ? parseFloat(this.record.AmountChecked) - this.previousInvoice.LZWAccumulatedChecked
          : 0;
        this.record.EGMZWAmount = this.record.EGMAmount
          ? parseFloat(this.record.EGMAmount) - parseFloat(this.previousInvoice.EGMAcc)
          : 0 - parseFloat(this.previousInvoice.EGMAcc);
        this.record.EGMAcc = this.previousInvoice.EGMAcc + this.record.EGMZWAmount;
        this.record.SEBZWAmount = this.record.SEBAmount
          ? parseFloat(this.record.SEBAmount) - parseFloat(this.previousInvoice.SEBAcc)
          : 0;
        this.record.SEBAcc = this.record.SEBAmount ? parseFloat(this.record.SEBAmount) : this.previousInvoice.SEBAcc;
      }

      this.record.GAAmount = this.record.LZWAccumulatedChecked - this.record.EGMAcc - this.record.SEBAcc;
      //console.log('zzz GAAmount', this.record.GAAmount);
      this.record.GAUStAmount = this.$utils.round((this.record.GAAmount * this.record.UStChecked) / 100);
      //console.log('zzz GAUStAmount', this.record.GAUStAmount);
      this.record.GABrutto = this.record.GAAmount + this.record.GAUStAmount;
      //console.log('zzz GABrutto', this.record.GABrutto);
      // ZAAmount           Zahl.anspruch netto
      this.record.ZAAmount = this.record.LZWAmountChecked - this.record.EGMZWAmount - this.record.SEBZWAmount;
      //console.log('zzz ZAAmount', this.record.ZAAmount);
      // ZAUStAmount        ZA USt.-Wert
      this.record.ZAUStAmount = this.record.UStChecked
        ? this.$utils.round((this.record.ZAAmount * this.record.UStChecked) / 100)
        : 0;
      //console.log('zzz ZAUStAmount', this.record.ZAUStAmount);
      // ZABrutto          (Zahl.anspruch\nbrutto o UStA.)
      this.record.ZABrutto = this.record.ZAAmount + this.record.ZAUStAmount;
      //console.log('zzz ZABrutto', this.record.ZABrutto);
      // ZAUStAmountSum     (Summe\n32_ZA_UStWert)
      //console.log('zzz ZAUStAmountSum', this.record.ZAUStAmountSum);
      // ZAUStAmountIncl   (ZA_UStWert\nInklAusgleich)

      this.record.ZAUStAmountIncl = this.record.GAUStAmount - this.record.ZAUStAmountSum;
      //console.log('zzz ZAUStAmountIncl', this.record.ZAUStAmountIncl);
      // UStAusgleich      USt-\nAusgleich
      this.record.UStAusgleich = this.record.ZAUStAmountIncl - this.record.ZAUStAmount;
      //console.log('zzz UStAusgleich', this.record.UStAusgleich);
      // ZABruttoIncl
      this.record.ZABruttoIncl = this.record.ZABrutto + this.record.UStAusgleich;
      //console.log('zzz ZABruttoIncl', this.record.ZABruttoIncl);
      // ZABruttoMaßgeblich     Zahl.Anspruch\nbrutto
      this.record.ZABruttoMaßgeblich =
        this.record.Type == 1 || this.record.Type == 2 ? this.record.ZABrutto : this.record.ZABruttoIncl;
      //console.log('zzz ZABruttoMaßgeblich', this.record.ZABruttoMaßgeblich);
      // SFMBasisAmount     SEB MH Basiswert
      //console.log('zzz MSicherVon', this.order.MSicherVon);
      if (this.order.MSicherVon == 0) {
        this.record.SFMBasisAmount = this.record.LZWAccumulatedChecked;
      } else if (this.order.MSicherVon == 1) {
        this.record.SFMBasisAmount =
          this.record.LZWAccumulatedChecked +
          this.$utils.round((this.record.LZWAccumulatedChecked * this.record.UStChecked) / 100);
      }
      //console.log('zzz SFMBasisAmount', this.record.SFMBasisAmount);
      // SFMMHAmount        SEB MH
      this.record.SFMMHAmount = this.record.SFMPercent
        ? this.$utils.round((this.record.SFMPercent * this.record.SFMBasisAmount) / 100)
        : 0;
      //console.log('zzz AmountCheckd', this.record.AmountChecked == null);
      //console.log('zzz SFMPercent', this.record.SFMPercent, this.record.SFMPercent == null);

      // Tryfix:
      /*
      this.record.SFMAmount =
        this.record.AmountChecked != null && this.record.SFMPercent != null && this.record.SFMPercent != ''
          ? this.record.SFMMHAmount
          : null;
          */
      this.record.SFMAmount = this.record.SFMMHAmount
        ? this.record.SFMMHAmount
        : parseFloat(this.record.SFMPercent) == 0
        ? 0
        : null;

      // SFMMHDeltaAmount   SEB MH Veränderung
      this.record.SFMMHDeltaAmount = this.record.SFMMHAmount - this.record.SFMPreviousAmount;

      //console.log('zzz SFMMHDeltaAmount', this.record.SFMMHDeltaAmount);
      // AZAmount           Auszahlung brutto
      this.record.AZAmount = this.record.ZABruttoMaßgeblich - this.record.EGMOAmount - this.record.SFMMHDeltaAmount;
      //console.log('zzz AZAmount', this.$utils.round(this.record.AZAmount));

      this.record.SkontoAmount = this.record.SkontoProzent
        ? this.$utils.round((this.record.AZAmount * parseFloat(this.record.SkontoProzent)) / 100)
        : null;
      //console.log('zzz SkontoAmount', this.record.SkontoAmount);
      this.$forceUpdate();
    },
    formatDecimals(number) {
      return number ? number.toFixed(2) : '0,00';
      /*  Wir haben uns dafür entschieden, in Formularfeldern kommastellen IMMER anzuzeugen, und in Tabellen abhängig von der EInstellung in den Projektsettings
      if (!number) {
        if (SettingsStore.settings['Centbetraege']) return '0,00';
        else return '0';
      }
      if (SettingsStore.settings['Centbetraege'] == true) {
        return this.$utils.round(parseFloat(number)).toFixed(2);
      } else return parseInt(number);
      */
    },
    onFormFieldKeyUp() {
      this.showValidations = false;
      if (this.$refs['AmountChecked']?.$refs.AmountChecked)
        this.$refs['AmountChecked'].$refs.AmountChecked.setCustomValidity('');
      this.recordFormChanged = true;
    },
    async onInvoiceCheckedChange() {
      if (this.record.Status == 2) {
        const confirmed = await this.$bvModal.msgBoxConfirm(
          'Alle bereits getätigen Eingaben werden zurückgesetzt. Sind Sie sicher, dass die Rechnung auf "ungeprüft" gestellt werden soll?',
          {
            title: 'Rechnungsprüfung',
            okTitle: 'Bestätigen',
            cancelTitle: 'Abbrechen',
            okVariant: 'danger',

            centered: true
          }
        );

        if (confirmed) {
          this.record.CheckedDate = null;
          this.record.Status = 1;
          this.record.AmountChecked = null;
          this.record.UStChecked = null;
          this.record.UStCheckedValue = null;
          this.record.AmountCheckedBrutto = null;
          this.record.EGMAmount = null;
          this.record.EGMProzent = null;
          this.record.EGMComment = null;
          this.record.EGMOAmount = null;
          this.record.EGMOComment = null;
          this.record.SEBAmount = null;
          this.record.SEBPercent = null;
          this.record.SkontoCheck = null;
          this.record.SkontoFrist = null;
          this.record.SkontoProzent = null;
          this.record.SFMCheck = null;
          this.record.SFMPercent = null;
          this.record.SFMAmount = null;
          this.onFormFieldKeyUp();
        }
      }
    },

    onSFMCheckChange() {
      this.recordFormChanged = true;
      if (this.record.SFMCheck) {
        this.record.SFMAmountBkp = this.record.SFMAmount;
        this.record.SFMPercentBkp = this.record.SFMPercent;
        this.record.SFMAmount = null;
        this.record.SFMPercent = null;
      } else {
        if (this.record.SFMAmountBkp) this.record.SFMAmount = this.record.SFMAmountBkp;
        if (this.record.SFMPercentBkp) {
          this.record.SFMPercent = this.record.SFMPercentBkp;
        } else {
          this.record.SFMPercent = this.order.MSicherProzent ? parseFloat(this.order.MSicherProzent) : 0;
          if (this.record.SFMPercent && this.record.AmountChecked) {
            this.record.SFMAmount =
              this.record.SFMPercent && this.record.AmountChecked
                ? parseFloat(((this.record.AmountChecked * this.record.SFMPercent) / 100).toFixed(2))
                : this.record.SFMAmount;
          }
        }
      }
    },

    onSkontoCheckChange() {
      this.recordFormChanged = true;
      if (!this.record.SkontoCheck) {
        this.record.SkontoFristBkp = this.record.SkontoFrist;
        this.record.SkontoProzentBkp = this.record.SkontoProzent;

        this.record.SkontoFrist = null;
        this.record.SkontoProzent = null;
        this.record.SkontoAmount = null;
      } else {
        if (this.record.SkontoFristBkp) this.record.SkontoFrist = this.record.SkontoFristBkp;
        if (this.record.SkontoProzentBkp) this.record.SkontoProzent = this.record.SkontoProzentBkp;

        if (!this.record.SkontoFrist || this.record.SkontoFrist == '') this.record.SkontoFrist = this.order.SkontoFrist;

        if (!this.record.SkontoProzent || this.record.SkontoProzent == '')
          this.record.SkontoProzent = this.order.Skonto;
        /*
        this.record.SkontoAmount =
          this.record.AmountChecked &&
          this.record.AmountChecked > 0 &&
          this.record.SkontoProzent &&
          this.record.SkontoProzent > 0
            ? (this.record.AmountChecked * this.record.SkontoProzent) / 100
            : null;*/
      }
    },
    onDecisionSelectChange() {
      if (this.record.Type == '1') {
        this.record.AmountCheckedType = 'Z';
        this.record.SEBAmount = null;
        this.record.SEBPercent = null;
      }
      if (this.record.Type == '2') this.record.AmountCheckedType = 'K';
      if (this.record.Type == '3') this.record.AmountCheckedType = 'K';
      if (this.record.Type != '3') {
        this.record.SFMPercent = null;
        this.calcComputedFields();
      }
      this.$forceUpdate();
      this.recordFormChanged = true;
    },
    scrollIntoView(which) {
      if (this.initialState) return;
      if (!this['collapse' + which + 'open']) return;
      /*
      var el = document.querySelector('#' + which);
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      */
      setTimeout(() => {
        var el = document.querySelector('.main-canvas');
        el.scrollTo({ top: 1000, behavior: 'smooth' });
        el = document.querySelector('#main-panel');
        el.scrollTop = 0;
      }, 200);
    }
  },
  computed: {
    canBeEdited() {
      if (this.record.Type == 3 && this.record.IsLast == 0) return false;
      if (this.record.Type < 3 && this.order.HasFinalInvoice > 0) return false;
      return true;
    },
    totalEGMO() {
      if (this.record.EGMOAmount == null || isNaN(this.record.EGMOAmount)) return this.record.SumPastEGMOAmount;
      const retVal = parseFloat(this.record.SumPastEGMOAmount) + parseFloat(this.record.EGMOAmount);
      if (isNaN(retVal)) return 0;
      return retVal;
    },
    isAmountCheckedLargerThanSum() {
      if (
        this.editMode &&
        this.showValidations &&
        (this.record.EGMAmount ? parseFloat(this.record.EGMAmount) : 0) +
          (this.record.SEBAmount ? parseFloat(this.record.SEBAmount) : 0) >
          (this.record.AmountChecked ? parseFloat(this.record.AmountChecked) : 0)
      ) {
        return false;
      } else return null;
    }
  }
};
</script>

<style>
#egmTypeSelector .form-group {
  margin-bottom: 0.5rem !important;
}
#checked-selector > label.btn {
  padding-left: 6px;
  padding-right: 6px;
  padding-top: 0px;
  padding-bottom: 0px;
  font-size: 80%;
}
#checked-selector > .btn:not(.active) {
  background-color: #ccc;
  color: white;
  border-color: #ccc;
}
</style>
